var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5469 118.656C40.5312 121.18 41.7969 123.727 43.9844 124.781L42.9219 126.172C41.3906 125.398 40.2891 123.906 39.6875 122.109C39.0703 124.031 37.9141 125.625 36.2969 126.438L35.2344 125.047C37.5078 123.969 38.8047 121.266 38.8125 118.656V116.406H40.5469V118.656ZM44.8281 129.391V115.266H46.5625V120.797H48.7344V122.281H46.5625V129.391H44.8281ZM61.0625 115.266V122.469H59.3438V115.266H61.0625ZM49.3125 121.094C51.6016 120.367 52.8047 118.555 52.7969 116.703V115.609H54.5938V116.703C54.5859 118.5 55.7812 120.18 58.0156 120.859L57.1719 122.203C55.5312 121.695 54.3594 120.648 53.7188 119.305C53.0781 120.766 51.875 121.914 50.1875 122.453L49.3125 121.094ZM51.7188 124.469V123.125H61.0938V126.797H53.4531V127.891H61.5156V129.266H51.75V125.5H59.3594V124.469H51.7188ZM68.1562 117.516C68.1562 119.289 69.3047 120.969 71.4844 121.656L70.5469 123.016C69.0234 122.5 67.9297 121.469 67.3125 120.156C66.7031 121.656 65.5625 122.836 63.9375 123.406L63 122.047C65.2734 121.258 66.4141 119.375 66.4219 117.359V116.016H68.1562V117.516ZM64.9219 126.688C64.9219 125.016 66.7578 124.023 69.7031 124.031C72.625 124.023 74.4297 125.016 74.4375 126.688C74.4297 128.398 72.625 129.375 69.7031 129.375C66.7578 129.375 64.9219 128.398 64.9219 126.688ZM66.6562 126.688C66.6562 127.562 67.7656 128 69.7031 128C71.6328 128 72.7188 127.562 72.7188 126.688C72.7188 125.859 71.6328 125.391 69.7031 125.391C67.7656 125.391 66.6562 125.859 66.6562 126.688ZM72.5625 123.719V115.266H74.2969V118.703H76.2656V120.141H74.2969V123.719H72.5625ZM91.9375 115.266V118.734H93.8906V120.156H91.9375V123.516H90.1875V115.266H91.9375ZM81.3281 122.625V116.266H87.6562V117.672H83.0469V121.219C85.75 121.211 87.2578 121.125 88.9219 120.781L89.0938 122.172C87.2656 122.562 85.6016 122.625 82.4688 122.625H81.3281ZM82.5469 126.562C82.5469 124.812 84.4062 123.781 87.3281 123.781C90.2266 123.781 92.0547 124.812 92.0625 126.562C92.0547 128.344 90.2266 129.375 87.3281 129.375C84.4062 129.375 82.5469 128.344 82.5469 126.562ZM84.2656 126.562C84.2578 127.477 85.3906 127.984 87.3281 127.984C89.2266 127.984 90.3672 127.477 90.375 126.562C90.3672 125.664 89.2266 125.164 87.3281 125.172C85.3906 125.164 84.2578 125.664 84.2656 126.562ZM99.6875 118.281C99.6797 119.844 100.891 121.305 103.109 121.906L102.312 123.25C100.664 122.805 99.4844 121.859 98.8359 120.641C98.2188 121.969 97.0391 123.016 95.3594 123.516L94.5312 122.156C96.7578 121.539 97.9531 119.953 97.9531 118.281V118.141H95V116.766H97.9531V115.203H99.7031V116.766H102.641V118.141H99.6875V118.281ZM97.0469 129.219V124.219H106.438V129.219H97.0469ZM98.7812 127.812H104.734V125.609H98.7812V127.812ZM102.266 120.469V119.062H104.703V115.266H106.438V123.578H104.703V120.469H102.266Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 49.0005C119.019 75.5258 97.5238 97.0205 70.9985 97.0205C44.4732 97.0205 22.9785 75.5258 22.9785 49.0005C22.9785 22.4751 44.4732 0.980469 70.9985 0.980469C97.5238 0.980469 119.019 22.4751 119.019 49.0005Z",
    fill: "url(#paint0_linear_1275_5267)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6904 51.2967C97.2578 50.8641 96.7489 50.6351 96.1637 50.6351H88.5046V40.6097L94.4079 34.6809C94.8405 34.2483 95.0695 33.7394 95.0695 33.1542C95.0695 32.5689 94.8405 32.06 94.4079 31.6275C93.9754 31.1949 93.4665 30.9659 92.8812 30.9659C92.296 30.9659 91.7871 31.1949 91.3545 31.6275L85.4512 37.5308H56.5707L50.6674 31.602C50.2348 31.1694 49.7259 30.9404 49.1407 30.9404C48.5554 30.9404 48.0465 31.1694 47.614 31.602C47.1814 32.0346 46.9524 32.5435 46.9524 33.1287C46.9524 33.714 47.1814 34.2229 47.614 34.6555L53.4918 40.6097V50.6606H45.8582C45.273 50.6606 44.7641 50.8896 44.3315 51.3222C43.8989 51.7547 43.6699 52.2636 43.6699 52.8489C43.6699 53.4341 43.8989 53.943 44.3315 54.3756C44.7641 54.8082 45.273 55.0372 45.8582 55.0372H53.5173C53.5173 58.6759 54.1788 61.8056 55.502 64.4011L48.6063 72.1619C48.2246 72.6199 48.0465 73.1543 48.072 73.7395C48.0974 74.3502 48.3519 74.8591 48.7844 75.2662C49.217 75.6225 49.7005 75.826 50.2603 75.826C50.8964 75.826 51.4562 75.597 51.8888 75.1136L58.1483 68.0397L58.6572 68.5232C58.988 68.8286 59.4715 69.1848 60.1331 69.6428C60.7946 70.0754 61.558 70.5334 62.3977 70.966C63.2374 71.3985 64.2298 71.7802 65.3748 72.0856C66.5198 72.3909 67.6903 72.5436 68.8354 72.5436V41.9074H73.212V72.5181C74.3061 72.5181 75.4003 72.3655 76.5199 72.0856C77.6395 71.7802 78.5809 71.4494 79.3189 71.0932C80.0822 70.737 80.8201 70.3044 81.5326 69.8464C82.2705 69.3883 82.7285 69.0576 82.9575 68.8794C83.1865 68.7013 83.3647 68.5487 83.4664 68.4469L90.2349 75.1899C90.642 75.6225 91.1509 75.8515 91.7616 75.8515C92.3723 75.8515 92.8812 75.6225 93.2883 75.1899C93.7209 74.7573 93.9499 74.2484 93.9499 73.6632C93.9499 73.0779 93.7209 72.569 93.2883 72.1364L86.1891 64.9863C87.7158 62.2637 88.4792 58.9812 88.4792 55.0881H96.1382C96.7235 55.0881 97.2324 54.8591 97.6649 54.4265C98.0975 53.9939 98.3265 53.485 98.3265 52.8998C98.3265 52.2382 98.123 51.7293 97.6904 51.2967Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7335 25.419C76.5961 23.2816 74.0261 22.2129 70.9981 22.2129C67.9701 22.2129 65.4002 23.2816 63.2628 25.419C61.1253 27.5564 60.0566 30.1264 60.0566 33.1544H81.9396C81.9396 30.1264 80.8709 27.531 78.7335 25.419Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.49 48.9999C113.49 72.4668 94.4668 91.4905 70.9999 91.4905C47.533 91.4905 28.5093 72.4668 28.5093 48.9999C28.5093 25.533 47.533 6.50933 70.9999 6.50933C94.4668 6.50933 113.49 25.533 113.49 48.9999Z",
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5267",
    x: 43.6699,
    y: 22.2129,
    width: 54.6562,
    height: 54.6649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5267",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5267",
    x1: 37.6785,
    y1: 11.4338,
    x2: 107.749,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/Bug.bdff171b9fa750b76e9f94899a49eaba.svg";
export { ForwardRef as ReactComponent };